import { EnvironmentConfig } from './environment-types';

export const environment: EnvironmentConfig = {
  configSource: import.meta.env?.['NG_APP_BWM_JSON_CONFIG'] || './assets/config/default.json',
  appBuildMode: 'bwm',
  appBuildModeLanguage: 'cs_bwm',
  defaultBtnShape: null,
  appLinkAndroid: 'https://play.google.com/store/apps/details?id=frontend.mnca.dev',
  appLinkIphone: 'https://apps.apple.com/cz/app/bwm-broker-wealth-management/id6471965895',
  facebookLink: 'https://www.facebook.com/profile.php?id=61561099056900',
  linkedinLink: 'https://www.linkedin.com/company/moneco-investicni-spolecnost-a-s',
};
